// extracted by mini-css-extract-plugin
module.exports = {"link":"InfoLint_link__J3Gvb"};